import { render, staticRenderFns } from "./EventEditorProgramFieldConfig.vue?vue&type=template&id=2679d8ae&scoped=true&"
import script from "./EventEditorProgramFieldConfig.vue?vue&type=script&lang=js&"
export * from "./EventEditorProgramFieldConfig.vue?vue&type=script&lang=js&"
import style0 from "./EventEditorProgramFieldConfig.vue?vue&type=style&index=0&id=2679d8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679d8ae",
  null
  
)

export default component.exports